export default __webpack_public_path__ + "static/media/diversity1.47cf2b5c.webp";